import { endOfDay, formatISO9075, startOfDay } from 'date-fns';

import {
  CreateCampaignFormStep01ExternalValuesOptionalFields,
  RestoredStep01ExternalData,
} from '@features/campaigns/builder/containers/FormPages/FormPages.types';
import { CampaignDetails, CampaignMediaTypes } from '@features/campaigns/shared/types/campaign.ts';
import {
  CreateCampaignStep01ExternalPayload,
  FormInterface,
} from '@features/campaigns/shared/types/campaignBuilderTypes.ts';

export function createCampaignStep01DTO<T extends boolean>(
  formValues: FormInterface<T>,
): CreateCampaignStep01ExternalPayload {
  const { name, budget, advertiserId } = formValues;
  const dateRange = formValues.dateRange || [];

  return {
    advertiserId,
    name,
    isNameAutoGenerated: false,
    isAgencyCommissionGross: false,
    budget: budget.toString(),
    startDate: formatISO9075(dateRange[0], { representation: 'date' }),
    endDate: formatISO9075(dateRange[1], { representation: 'date' }),
    mediaType: CampaignMediaTypes.CTV,
  };
}

export function restoreStep01ExternalDataDTO(data: CampaignDetails): RestoredStep01ExternalData {
  const startDate = startOfDay(new Date(data.startDate));
  const endDate = endOfDay(new Date(data.endDate));

  const restoredCoreData = {
    id: data.id,
    status: data.status,
    createdBy: data.createdBy,
    name: data.name,
    dateRange: [startDate, endDate],
    budget: data.budget,
  };

  if (data.billingContact) {
    return {
      ...restoredCoreData,
      advertiserId: data.advertiser.id,
      advertiserName: data.advertiser.name,
      advertiserCode: data.advertiser.code,
      billingContactId: data.billingContact.id,
      billingContactCode: data.billingContact.code,
      billingContactName: data.billingContact.name,
    };
  }

  return restoredCoreData;
}

export function restoreStep01ExternalFormValues(
  data: RestoredStep01ExternalData,
): CreateCampaignFormStep01ExternalValuesOptionalFields {
  return {
    advertiserId: data.advertiserId,
    billingContactId: data.billingContactId,
    name: data.name,
    dateRange: data.dateRange,
    budget: data.budget,
  };
}
